import React, { useCallback } from "react";

const LastPassageCell = ({
  data,
  value,
  valueFormatted,
  setIdLastPassage,
  setOpenLastPassage,
}) => {
  const formatLastPassageDate = useCallback((date) => {
    if (!date) return "";

    if (date instanceof Date) {
      return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("pt-BR");
    }

    const dateValue = String(date).trim();
    const brDateMatch = dateValue.match(/^([0-9]{2}\/[0-9]{2}\/[0-9]{4})/);

    if (brDateMatch) return brDateMatch[1];

    const isoDateMatch = dateValue.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})/);

    if (isoDateMatch) {
      const [, year, month, day] = isoDateMatch;
      return day + "/" + month + "/" + year;
    }

    const dateObj = new Date(dateValue);

    return Number.isNaN(dateObj.getTime()) ? dateValue : dateObj.toLocaleDateString("pt-BR");
  }, []);

  const time = formatLastPassageDate(valueFormatted ?? value);

  return (
    <span
      className="hover:underline cursor-pointer truncate"
      onClick={() => {
        setIdLastPassage(data);
        setOpenLastPassage(true);
      }}
    >
      {time}
    </span>
  );
};

export default LastPassageCell;
